(() => {
  if (customElements.get('card-product')) {
    return;
  }

  class CardProduct extends HTMLElement {
    constructor() {
      super();
      this.variantsImages = null;
      this.imageElement = null;
      this.mediaLink = null;
      this.swatchInputs = [];
      this.swatchInputslabels = [];
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Get the variants images data from the script tag
      const variantsImagesScript = this.querySelector('[data-variants-images]');
      if (!variantsImagesScript) return;

      try {
        this.variantsImages = JSON.parse(variantsImagesScript.textContent);
      } catch (error) {
        console.error('Error parsing variants images data:', error);
        return;
      }

      // Find the image element inside the media container
      const mediaContainer = this.querySelector('.media');
      if (!mediaContainer) return;

      // Store the media link element (the <a> tag)
      this.mediaLink = mediaContainer;
      if (!this.mediaLink) return;

      // Find the img element (could be lazy-loaded or regular)
      this.imageElement = mediaContainer.querySelector('img');
      if (!this.imageElement) return;

      // Get color option position from swatches container
      const swatchesContainer = this.querySelector('.card-product__swatches');
      this.colorOptionPosition = swatchesContainer
        ? parseInt(swatchesContainer.dataset.colorOptionPosition, 10)
        : null;

      // Get all swatch inputs within this card (including those without data-variant-id)
      this.swatchInputs = this.querySelectorAll(
        '.card-product__swatches input[type="radio"], .card-product__swatches input[type="checkbox"]'
      );

      this.swatchInputslabels = this.querySelectorAll(
        '.card-product__swatches label'
      );

      // Add event listeners to swatch inputs
      this.swatchInputs.forEach((input) => {
        input.addEventListener('change', this.handleSwatchChange.bind(this));
      });

      // Change swatch on hover
      this.swatchInputslabels.forEach((label) => {
        label.addEventListener('mouseenter', (event) => {
          const input = label.closest('.swatch__holder').querySelector('input');

          input.click();
        });
      });
    }

    handleSwatchChange(event) {
      if (!this.variantsImages) return;

      let variantImageData = null;
      const variantId = event.target.dataset.variantId;

      // Try to find variant by variant ID first (if available)
      if (variantId) {
        variantImageData = this.variantsImages.find(
          (variant) => variant.id === parseInt(variantId, 10)
        );
      }

      // If not found, try to find by matching option value
      if (!variantImageData && this.colorOptionPosition) {
        const optionValue = event.target.value;
        const optionKey = `option${this.colorOptionPosition}`;

        // Find first variant that matches this option value and has an image
        variantImageData = this.variantsImages.find((variant) => {
          return (
            variant[optionKey] === optionValue &&
            variant.image &&
            variant.image.src
          );
        });

        // If still not found, find any variant with this option value
        if (!variantImageData) {
          variantImageData = this.variantsImages.find(
            (variant) => variant[optionKey] === optionValue
          );
        }
      }

      if (!variantImageData || !variantImageData.image) return;

      // Update the image
      this.updateImage(variantImageData.image);

      // Update the link href with variant URL
      if (variantImageData.url && this.mediaLink) {
        this.mediaLink.setAttribute('href', variantImageData.url);
      }
    }

    updateImage(imageData) {
      if (!this.imageElement || !imageData) return;

      const isLazyLoaded = this.imageElement.classList.contains('lazyload');

      if (isLazyLoaded) {
        // Update lazy-loaded image attributes
        this.imageElement.setAttribute('data-src', imageData.src);
        if (imageData.srcset) {
          this.imageElement.setAttribute('data-srcset', imageData.srcset);
        }

        // Trigger lazy loading if lazysizes is available
        if (window.lazySizes) {
          lazySizes.loader.unveil(this.imageElement);
        }
      } else {
        // Update regular image attributes
        this.imageElement.setAttribute('src', imageData.src);
        if (imageData.srcset) {
          this.imageElement.setAttribute('srcset', imageData.srcset);
        }
      }
    }
  }

  customElements.define('card-product', CardProduct);
})();

